import { render, staticRenderFns } from "./OssImg.vue?vue&type=template&id=6710ef7a&scoped=true"
import script from "./OssImg.vue?vue&type=script&lang=js"
export * from "./OssImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710ef7a",
  null
  
)

export default component.exports